import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Box,
  useTheme,
  useMediaQuery,
  Drawer,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate, Link } from "react-router-dom";

export default function Header({ toggleDarkMode, isDarkMode }) {
  const [anchorEls, setAnchorEls] = useState({});
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const dropdownData = {
    Products: [
      { label: 'CTMS', path: '/ctms' },
      { label: 'Informer', path: '/informer' },
      { label: 'Insights RM', path: '/insights-rm' },
      { label: 'Professional Services', path: '/Professional-Services' },
      { label: 'Intrinsic BioPhy', path: '/intrinsic-biophy'  }
    ],
    Resources: [
      { label: 'Articles', path: '/articles' },
      { label: 'Videos', path: '/videos' },
      { label: 'Conferences', path: '/conference' }
    ],
    Company: [
      { label: 'About Page', path: '/about' },
      { label: 'Leadership Page', path: '/leadership' },
      { label: 'Careers Page', path: '/careers' },
    ],
  };

  const openMenu = (event, key) => {
    setAnchorEls({ ...anchorEls, [key]: event.currentTarget });
  };

  const closeMenu = (key) => {
    setAnchorEls({ ...anchorEls, [key]: null });
  };

  const toggleDrawer = () => setMobileOpen(!mobileOpen);

  const navItemStyle = {
    fontSize: "1rem",
    fontWeight: 500,
    textTransform: "none",
    color: theme.palette.text.primary,
    "&:hover": { color: theme.palette.primary.main }
  };

  // Desktop Menus
  const renderMenu = (name) => (
    <Menu
      anchorEl={anchorEls[name]}
      open={Boolean(anchorEls[name])}
      onClose={() => closeMenu(name)}
    >
      {dropdownData[name].map((item, i) => (
        <MenuItem 
          key={i}
          onClick={() => { navigate(item.path); closeMenu(name); }}
        >
          {item.label}
        </MenuItem>
      ))}
    </Menu>
  );

  // Mobile Drawer
 const drawer = (
  <Drawer anchor="left" open={mobileOpen} onClose={toggleDrawer}>
    <Box sx={{ width: 260, pt: 3 }}>

      {Object.keys(dropdownData).map((menu, i) => (
        <Box key={i}>
          
          {/* Parent Menu (tap to expand) */}
          <ListItemButton
            onClick={() =>
              setMobileExpanded(mobileExpanded === menu ? null : menu)
            }
          >
            <ListItemText 
              primary={menu}
              primaryTypographyProps={{ fontWeight: 700 }}
            />
          </ListItemButton>

          {/* Submenu items - show ONLY when expanded */}
          {mobileExpanded === menu && (
            <Box sx={{ pl: 4 }}>
              {dropdownData[menu].map((item, idx) => (
                <ListItemButton
                  key={idx}
                  onClick={() => {
                    navigate(item.path);
                    toggleDrawer();
                  }}
                >
                  <ListItemText primary={item.label} />
                </ListItemButton>
              ))}
            </Box>
          )}

        </Box>
      ))}

    </Box>
  </Drawer>
);



  return (
    <>
      <AppBar
        position="sticky"
        color="default"
        elevation={1}
        sx={{
          height: 70,
          display: "flex",
          justifyContent: "center",
          backgroundColor: "rgba(255,255,255,0.8)",
          backdropFilter: "blur(8px)"
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", px: { xs: 2, md: 4, lg: 8 } }}>

          {/* Logo */}
          <Box display="flex" alignItems="center" gap={1} sx={{ cursor: "pointer" }} onClick={() => navigate("/")}>
            <img src="/logo.svg" alt="logo" style={{ height: 46 }} />
            <Box lineHeight={1}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>INTRINSIC</Typography>
              <Typography variant="caption" sx={{ fontWeight: 700 }}>CLINICAL SYSTEMS</Typography>
            </Box>
          </Box>

          {/* Navigation */}
          {isMobile ? (
            <IconButton onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
          ) : (
            <Box display="flex" alignItems="center" gap={4}>
              {Object.keys(dropdownData).map((menu, i) => (
                <Box key={i} onMouseEnter={(e) => openMenu(e, menu)} onMouseLeave={() => closeMenu(menu)}>
                  <Button endIcon={<ArrowDropDownIcon />} sx={navItemStyle}>
                    {menu}
                  </Button>
                  {renderMenu(menu)}
                </Box>
              ))}
            </Box>
          )}

          {/* Icons + Remove Request Demo for mobile */}
          <Box display="flex" alignItems="center" gap={2}>
            <IconButton onClick={toggleDarkMode}>
              {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>

            {/* Hide Request Demo on mobile */}
            {!isMobile && (
              <Button 
                variant="contained"
                component={Link}
                to="/request-demo"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  px: 4,
                  borderRadius: "18px"
                }}
              >
                Request Demo
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {drawer}
    </>
  );
}
